import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface BlockUserRequest {
  requestor_key: string;
  reason?: string;
}

export interface ActiveUserBlock {
  requestor_key: string;
  gmid: string | null;
  email: string | null;
  reason: string | null;
  blocked_at: string;
  blocked_by: string;
}

export interface ListBlocksResponse {
  blocks: ActiveUserBlock[];
}

export interface BlockUserResponse {
  block: Pick<ActiveUserBlock, 'requestor_key' | 'reason' | 'blocked_at' | 'blocked_by'> & {
    is_blocked: true;
  };
}

export interface UnblockUserResponse {
  block: {
    requestor_key: string;
    is_blocked: false;
    unblocked_at: string;
    unblocked_by: string;
  };
}

export const REQUESTOR_KEY_MAX_LENGTH = 256;
export const BLOCK_REASON_MAX_LENGTH = 500;

@Injectable({ providedIn: 'root' })
export class RequestBlockService {
  private readonly baseURL = `${environment.backend_base_url}/api/admin/request-blocks`;

  constructor(private _http: HttpClient) {}

  listBlocks(): Observable<ListBlocksResponse> {
    return this._http.get<ListBlocksResponse>(this.baseURL);
  }

  blockUser(body: BlockUserRequest): Observable<BlockUserResponse> {
    return this._http.post<BlockUserResponse>(this.baseURL, body);
  }

  unblockUser(requestorKey: string): Observable<UnblockUserResponse> {
    return this._http.delete<UnblockUserResponse>(`${this.baseURL}/${encodeURIComponent(requestorKey)}`);
  }
}
